<script>
import BaseWidgetForm from './BaseWidgetForm'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'General',
          fields: [...this.getCommonFields()]
        }
      ]
    }
  }
}
</script>
